module.exports = __webpack_public_path__ + "img/42_35.4e89ae98.png";